import { IStrikeTypeReducer, IStrikeType } from 'models/StrikeType'
import { Action } from 'redux'
import { isType } from 'ts-action'
import { updateArray, deleteFromArray } from 'helpers/helperFunctions'
import {
  GetStrikeTypes,
  StrikeTypesFetching,
  UpdateStrikeType,
  DeleteStrikeType,
  AddStrikeType,
} from './actions'

const initialState: IStrikeTypeReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const strikeTypesReducer = (state = initialState, action: Action): IStrikeTypeReducer => {
  if (isType(action, GetStrikeTypes)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }
  if (isType(action, AddStrikeType)) {
    const { payload } = action
    const { data } = state
    const newArray = [payload.data, ...data]
    return {
      ...state,
      data: newArray,
    }
  }
  if (isType(action, UpdateStrikeType)) {
    const { payload } = action
    const { data } = state
    const formattedArray = updateArray<IStrikeType>(data, payload.data)
    return {
      ...state,
      data: formattedArray,
    }
  }
  if (isType(action, DeleteStrikeType)) {
    const { payload } = action
    const { data } = state
    const formattedArray = deleteFromArray<IStrikeType>(data, payload)
    return {
      ...state,
      data: formattedArray,
    }
  }

  if (isType(action, StrikeTypesFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
